module.exports = __webpack_public_path__ + "static/media/icon-check-circle.5e2b240b.svg";